import * as THREE from "three"; 
import LpApp from "../LpApp.js";

export default class Floor
{
    constructor()
    {
        this.lpApp = new LpApp();

        this.SetGeometry();
        this.SetTextures();
        this.SetMaterial();
        this.SetMesh();
    }

    SetGeometry()
    {
        this.Geometry = new THREE.CircleGeometry(5, 64);
    }

    SetTextures()
    {
        this.Textures = {};
        this.Textures.color = this.lpApp.Resources.items.grassColorTexture;
        this.Textures.color.colorSpace = THREE.SRGBColorSpace;
        this.Textures.color.repeat.set(1.5,1.5);
        this.Textures.color.wrapS = THREE.RepeatWrapping;
        this.Textures.color.wrapT = THREE.RepeatWrapping;
        
        this.Textures.normal = this.lpApp.Resources.items.grassNormalTexture;
        this.Textures.normal.repeat.set(1.5, 1.5);
        this.Textures.normal.wrapS = THREE.RepeatWrapping;
        this.Textures.normal.wrapT = THREE.RepeatWrapping;
    }

    SetMaterial()
    {
        this.Material = new THREE.MeshStandardMaterial({
            map: this.Textures.color,
            normalMap: this.Textures.normal
        });
        
    }

    SetMesh()
    {
        this.Mesh = new THREE.Mesh(this.Geometry, this.Material);
        this.Mesh.rotation.x = - Math.PI * 0.5;
        this.Mesh.receiveShadow = true;
        this.lpApp.Scene.add(this.Mesh);
    
    }
}